import { setLocalStorageValue } from "utils/localStorage";

const QUERY_ORIGIN = {
	AUTOCOMPLETE: "AUTOCOMPLETE",
	QUERY: "QUERY",
};

const siteSearchStorageKey = "siteSearch";

const useSearchTracking = (searchAutocomplete) => {
	const saveOrigin = (response, origin = QUERY_ORIGIN.AUTOCOMPLETE) => {
		if (!searchAutocomplete) return;
		setLocalStorageValue(siteSearchStorageKey, {
			queryOrigin: origin,
			queryOriginId: response?.queryId ?? null,
		});
	};

	const getSiteSearchStorage = () => {
		const siteSearchStorage = localStorage.getItem(siteSearchStorageKey);
		return siteSearchStorage ? JSON.parse(siteSearchStorage) : null;
	};

	return {
		siteSearchStorage: getSiteSearchStorage(),
		saveAutocompleteSelection: (response) => saveOrigin(response),
		saveQuerySearch: (response) => saveOrigin(response, QUERY_ORIGIN.QUERY),
	};
};

export default useSearchTracking;
